import  NotificationsSharpIcon from '@mui/icons-material/NotificationsSharp'
import MessageSharpIcon from '@mui/icons-material/MessageSharp'

const getAppbarOptions = ({ callback, user, params }) => {
  callback([]) //Notifications, chatmessages, or anything on the right side of the main appbar
}
export default getAppbarOptions
